import React from "react";

// Shared footer for CFAS pages.
// Usage: <CFASFooter/>
// Brand colours from the Samaggi guide: #002B1B, #C3A56A.

const CONTACT_EMAIL = "careers@samaggisamagom.com";

// TODO: point these at the real pages once they exist.
const PRIVACY_URL = "#";
const TERMS_URL = "#";

export const CFASFooter: React.FC = () => {
    return (
        <footer className="cff">
            <style>{CSS}</style>
            <div className="cff-in">
                <p className="cff-brand">
                    <strong>Samaggi Samagom</strong>, CFAS, the career and SACC platform
                </p>
                <nav className="cff-links" aria-label="Footer">
                    <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
                    <a href={PRIVACY_URL}>Privacy Policy</a>
                    <a href={TERMS_URL}>Terms</a>
                </nav>
            </div>
        </footer>
    );
};

const CSS = `
.cff{
  --deep:#002B1B;--gold:#C3A56A;
  --f-display:"soleil","Soleil","Outfit",system-ui,sans-serif;
  --f-body:"proxima-nova","Proxima Nova","Figtree",system-ui,sans-serif;
  background:var(--deep);color:rgba(255,255,255,.72);font-family:var(--f-body);font-size:.85rem;
  border-top:1px solid rgba(255,255,255,.08);
}
.cff *{box-sizing:border-box}
.cff-in{max-width:1120px;margin:0 auto;padding:16px 20px;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:6px 24px}
.cff-brand{margin:0}
.cff-brand strong{color:#fff;font-family:var(--f-display);font-weight:700}
.cff-links{display:flex;flex-wrap:wrap;align-items:center;gap:8px 20px}
.cff-links a{color:rgba(255,255,255,.72);text-decoration:none}
.cff-links a:hover{color:#fff;text-decoration:underline;text-underline-offset:3px}
.cff-links a:focus-visible{outline:2px solid var(--gold);outline-offset:2px;border-radius:2px}
`;

export default CFASFooter;